/**
 * Created by mac on 10/6/20
 */

const AdminLevelMiniature = {
    generate: function (adminLevel, size) {
        const bg = AdminLevelMiniature.default();

        const MiniatureGenerator = AdminLevelMiniature[cleverapps.config.name] || AdminLevelMiniature[cleverapps.config.type];
        if (MiniatureGenerator) {
            try {
                const miniature = MiniatureGenerator(adminLevel);
                cleverapps.UI.fitToBox(miniature, size || cleverapps.styles.AdminLevelMiniature);
                bg.addChild(miniature);
                miniature.setAlignment(cleverapps.styles.AdminLevelMiniature);
            } catch (e) {
                console.log(`Error in level miniature ${cleverapps.humanReadableNumber(adminLevel.episodeNo, adminLevel.levelNo)}`, e);
            }
        }

        return bg;
    },

    battlefield: function (adminLevel) {
        const game = new FakeGame(adminLevel);

        const battlefieldView = new BattlefieldView();
        for (let x = 0; x < Battlefield.GRID.x / 2; x++) {
            for (let y = 0; y < Battlefield.GRID.y; y++) {
                battlefieldView.cells[x][y].setVisible(false);
                const squad = game.battlefield.findSquad(x, y);
                if (squad) {
                    squad.remove();
                }
            }
        }
        battlefieldView.scale = 1;

        battlefieldView.setupDragListener.remove();

        const wrap = new cc.Node();
        wrap.setContentSize2(
            battlefieldView.width / 2,
            battlefieldView.height + 2 * cleverapps.styles.BattlefieldView.additionalHeight
        );
        wrap.addChild(battlefieldView);
        battlefieldView.setAlignment(-wrap.width, 0);

        return wrap;
    },

    merge: function (adminLevel) {
        const locationConfig = cleverapps.meta.getLocationMeta(adminLevel.location).locationConfig;

        const bundle = bundles[locationConfig.locationBundleId];

        const game = new FakeMerge(adminLevel);

        const slot = cleverapps.dataSlots.getSlot("fake");

        const map = new Map2d(slot, adminLevel.map, {
            units: bundle.meta.units,
            tiles: bundle.meta.tiles,
            visibleBox: adminLevel.visibleBox,
            terrains: adminLevel.terrains,
            regions: adminLevel.regions,
            field: adminLevel.field,
            background: adminLevel.background,
            waterBorder: 0
        });

        map.layers = [
            // map.layers[Map2d.LAYER_WATER],
            [[]],
            [[]],
            // [[]],
            map.layers[Map2d.LAYER_GROUND],
            [[]],
            [[]],
            [[]],
            [[]]
        ];

        game.map = map;

        const view = new Map2dInnerView(map);

        const wrap = new cc.Node();
        wrap.setContentSize2(view.width, view.height);
        wrap.setAnchorPoint(0.5, 0.5);

        view.setAlignment({ align: "center" }, { align: "center" });

        wrap.addChild(view);

        view.setVisibleRect(cc.rect(0, 0, view.width, view.height));

        return wrap;
    },

    wordsoup: function (location) {
        const slot = cleverapps.dataSlots.getSlot("fake");

        const map = new Map2d(slot, location.map, {
            tiles: location.tiles,
            units: location.units,
            visibleBox: location.visibleBox,
            regions: location.regions,
            decorators: location.decorators,
            terrains: location.terrains,
            field: location.field,
            background: location.background,
            families: location.families
        });
        Map2d.InsertDefaults(map, location.field);

        const view = new Map2dInnerView(map);

        const wrap = new cc.Node();
        wrap.setContentSize2(view.width, view.height);
        wrap.setAnchorPoint(0.5, 0.5);

        view.setAlignment({ align: "center" }, { align: "center" });

        wrap.addChild(view);

        view.setVisibleRect(cc.rect(0, 0, view.width, view.height));

        return wrap;
    },

    default: function () {
        const bg = cleverapps.UI.createScale9Sprite(bundles.admin.frames.lvl_miniature_bg);
        bg.setContentSize2(cleverapps.styles.AdminLevelMiniature.bg);
        return bg;
    },

    tileGame: function (adminLevel, orientation) {
        const game = new FakeGame(adminLevel);
        const table = Game.currentGame.table = cleverapps.config.type === "solitaire" ? new CardTable() : new TileTable();
        const screen = Game.currentGame.level.content.screens[0];
        let cards = screen.cards || screen.horizontalCards;
        if (orientation === undefined) {
            if (screen.horizontalCards && cleverapps.resolution.mode === cleverapps.WideMode.HORIZONTAL) {
                cards = screen.horizontalCards;
            }
        } else if (orientation === TileTable.ORIENTATION_HORIZONTAL) {
            cards = screen.horizontalCards;
        }

        table.setCards(cards, TileTable.ListMagicCards(screen), screen.maxValue);
        table.setRect();

        const view = new CardTableView(table);
        table.onResize();
        table.flipNormalize();
        table.showCards(() => {}, true);

        cleverapps.UI.fitToBox(view, cleverapps.styles.AdminLevelMiniature);

        view.addCleaner(() => {
            if (Game.currentGame === game) {
                delete Game.currentGame;
            }
        });

        return view;
    },

    scramble: function (adminLevel) {
        const text = cleverapps.UI.generateOnlyText(adminLevel.hint, cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
        text.setHorizontalAlignment(cc.TEXT_ALIGNMENT_LEFT);
        text.setVerticalAlignment(cc.VERTICAL_TEXT_ALIGNMENT_TOP);
        text.setDimensions(cleverapps.styles.AdminLevelMiniature.width, cleverapps.styles.AdminLevelMiniature.height / 2);
        return text;
    },

    differences: function (adminLevel) {
        const placeholder = new cc.Node();
        placeholder.setContentSize2(cleverapps.styles.AdminLevelMiniature);
        placeholder.setAnchorPoint(0.5, 0.5);

        const loading = new cc.Sprite(bundles.admin.frames.loading_png);
        placeholder.addChild(loading);
        loading.setAlignment(placeholder.width / 2, placeholder.height / 2);

        const game = new FakeGame(adminLevel);
        const name = game.level.getImageBundle();
        if (bundles[name]) {
            cleverapps.bundleLoader.loadBundle(name, {
                onSuccess: function () {
                    const view = new cc.Sprite(bundles[name].urls.a);
                    const w = view.width;
                    const h = view.height;
                    const frame = new cc.Sprite(bundles[name].urls.a, cc.rect((w - h) / 2, 0, h, h));

                    cleverapps.UI.fitToBox(frame, cleverapps.styles.AdminLevelMiniature);
                    placeholder.addChild(frame);
                    frame.setAlignment(placeholder.width / 2, placeholder.height / 2);

                    loading.removeFromParent();
                }
            });
        }

        return placeholder;
    },

    board: function (adminLevel) {
        let badWords = 0;
        let maxLength = 0;
        let mainWordsCount = 0;
        const words = adminLevel.words.map((word, id) => {
            if (word.length > maxLength) {
                maxLength = word.length;
                mainWordsCount = 1;
                badWords = 0;
            } else if (word.length === maxLength) {
                mainWordsCount++;
            }
            let badWord = false;
            if ((word.length > 3 && word.lastIndexOf("ing") === word.length - 3) || word.lastIndexOf("s") === word.length - 1
                || word.lastIndexOf("ed") === word.length - 2) {
                badWord = true;
                badWords++;
            }
            return `${id + 1}. ${word}${badWord ? " *" : ""}`;
        }).join("\n");

        return cleverapps.UI.generateOnlyText(words, badWords === mainWordsCount ? cleverapps.styles.FONTS.ADMIN_RED_TEXT : cleverapps.styles.FONTS.ADMIN_DATA_TEXT);
    },

    bundles: {
        match3: function () {
            let result = [];

            if (typeof Editor !== "undefined") {
                result = result.concat(Editor.BUNDLES.filter((bundle) => bundles[bundle]));
            }

            return result;
        }
    },

    match3: function (adminLevel) {
        const game = new FakeGame(adminLevel);

        const view = AdminLevelMiniature._match3(game, adminLevel);

        view.addCleaner(() => {
            if (Game.currentGame === game) {
                delete Game.currentGame;
            }
        });

        return view;
    },

    _match3: function (game, adminLevel) {
        const field = game.field;
        adminLevel.gameField = field;

        field.load(adminLevel);

        const fieldView = new cc.Node();
        fieldView.setAnchorPoint(0.5, 0.5);

        const cellIterator = function (cell) {
            if (cell.innerCell) {
                cellIterator(cell.innerCell);
            }
            const ViewClass = cell.getViewClass();
            const cellView = new ViewClass(cell);
            fieldView.addChild(cellView);
        };

        field.iterateCells(cellIterator);

        cleverapps.UI.wrap(fieldView);

        const view = new cc.Node();
        view.setContentSize(fieldView.width, fieldView.height);
        view.setAnchorPoint(0.5, 0.5);
        view.addChild(fieldView);

        fieldView.setAlignment(view.width / 2, view.height / 2);
        fieldView.setAnchorPoint(0.5, 0.5);

        const floorView = new FloorView(field);
        floorView.setContentSize(view.width, view.height);
        floorView.setAlignment(view.width / 2, view.height / 2);
        floorView.setLocalZOrder(-1);
        floorView.setAnchorPoint(0.5, 0.5);
        view.addChild(floorView);

        const tileIterator = function (tile) {
            const ViewClass = tile.getViewClass();
            const tileView = new ViewClass(tile);
            floorView.addChild(tileView);
        };

        field.iterateTiles(tileIterator);

        const barriersView = new BarriersView(field, BaseCellView.alignInTheGrid);
        barriersView.setContentSize(view.width, view.height);
        barriersView.setAlignment(view.width / 2, view.height / 2);
        barriersView.setLocalZOrder(-1);
        barriersView.setAnchorPoint(0.5, 0.5);
        view.addChild(barriersView);

        for (let i = 0; i < Field.SIZE; i++) {
            for (let j = 0; j < Field.SIZE; j++) {
                if (field.cells[i][j]) {
                    field.cells[i][j].onAfterExplodeListener = function () {};
                }
                if (field.floor[i][j]) {
                    field.floor[i][j].onAfterExplodeListener = function () {};
                }
            }
        }

        return view;
    },

    blocks: function (adminLevel) {
        const grid = new Grid(adminLevel.content);
        const view = new GridView(grid);
        view.pointHandler.remove();
        cleverapps.UI.fitToBox(view, cleverapps.styles.AdminLevelMiniature);
        return view;
    }
};

AdminLevelMiniature.tile3 = AdminLevelMiniature.solitaire = AdminLevelMiniature.tileGame;

cleverapps.styles.AdminLevelMiniature = {
    width: 125,
    height: 125,

    x: { align: "center", dx: 0 },
    y: { align: "center", dy: 0 },

    bg: {
        width: 135,
        height: 135
    }
};
